<nav
    class="sidenav"
    [class.sidenav--expanded]="expanded()"
    aria-label="Main navigation"
    i18n-aria-label="@@sidenav-aria-label">
    <ul class="sidenav__list" role="list">
        <!-- Community -->
        <li class="sidenav__list-item">
            <a
                matButton
                class="sidenav__link"
                [routerLink]="auth.isCommunityMember() ? ['/scope-community/community-members'] : ['/scope-community']"
                routerLinkActive="sidenav__link--active"
                #communityRef="routerLinkActive"
                (click)="closeAllMenus()"
                matTooltip="Community"
                [matTooltipDisabled]="expanded()"
                matTooltipPosition="after">
                <mat-icon
                    class="sidenav__icon riege-icon md-24 material-icons"
                    [class.material-icons-outlined]="!communityRef.isActive"
                    aria-hidden="true"
                    >hub</mat-icon
                >
                <span class="sidenav__label">Community</span>
            </a>
        </li>

        <!-- Tools -->
        <li class="sidenav__list-item">
            <a
                matButton
                class="sidenav__link sidenav__link--trigger"
                [class.sidenav__link--active]="isRouteActive(['/tools'])"
                [matMenuTriggerFor]="toolsMenu"
                #toolsTrigger="matMenuTrigger"
                tabindex="0"
                (keydown.enter)="toolsTrigger.openMenu()"
                (menuOpened)="onMenuOpened(toolsTrigger)"
                i18n-aria-label="@@menu-item-tools-menu"
                aria-label="Tools">
                <mat-icon
                    class="sidenav__icon riege-icon md-24 material-icons"
                    [class.material-icons-outlined]="!isRouteActive(['/tools'])"
                    aria-hidden="true"
                    >cases</mat-icon
                >
                <span class="sidenav__label" i18n="@@menu-item-tools-menu">Tools</span>
            </a>

            <mat-menu #toolsMenu="matMenu" xPosition="after" [overlapTrigger]="false" class="riege-menu sidenav__menu">
                <div>
                    @if (!expanded()) {
                        <p class="sidenav__menu-heading" mat-menu-item disabled i18n="@@menu-item-tools-menu">Tools</p>
                    }
                    <a mat-menu-item tabindex="0" routerLink="/tools/scope-runtime" routerLinkActive="active"
                        >Scope Runtime</a
                    >

                    <a
                        mat-menu-item
                        tabindex="0"
                        routerLink="/tools/exchange-rate-calculator"
                        routerLinkActive="active"
                        i18n="@@menu-item-exchange-rate-calculator"
                        >Exchange rate calculator</a
                    >

                    @if (showUnLocodes) {
                        <a mat-menu-item tabindex="0" routerLink="/tools/unlocodes" routerLinkActive="active"
                            >UN/LOCODEs</a
                        >
                    }
                </div>
            </mat-menu>
        </li>

        <!-- Only for RSI Super Admin -->
        @if (auth.isSuperAdmin()) {
            <li class="sidenav__list-item">
                <a
                    matButton
                    class="sidenav__link sidenav__link--trigger"
                    [class.sidenav__link--active]="isRouteActive(['/service', '/tenants'])"
                    [matMenuTriggerFor]="serviceMenu"
                    #serviceTrigger="matMenuTrigger"
                    tabindex="0"
                    (keydown.enter)="serviceTrigger.openMenu()"
                    (menuOpened)="onMenuOpened(serviceTrigger)"
                    i18n-aria-label="@@menu-item-service-menu"
                    aria-label="Service">
                    <mat-icon
                        class="sidenav__icon riege-icon md-24 material-icons"
                        [class.material-icons-outlined]="!isRouteActive(['/service', '/tenants'])"
                        aria-hidden="true"
                        >rocket_launch</mat-icon
                    >
                    <span class="sidenav__label" i18n="@@menu-item-service-menu">Service</span>
                </a>

                <mat-menu
                    #serviceMenu="matMenu"
                    xPosition="after"
                    [overlapTrigger]="false"
                    class="riege-menu sidenav__menu">
                    <div>
                        @if (!expanded()) {
                            <p class="sidenav__menu-heading" mat-menu-item disabled i18n="@@menu-item-service-menu"
                                >Service</p
                            >
                        }
                        <a
                            mat-menu-item
                            tabindex="0"
                            routerLink="/tenants"
                            routerLinkActive="active"
                            i18n="@@menu-item-tenants"
                            >Scope tenants</a
                        >

                        @if (showService) {
                            <a
                                mat-menu-item
                                tabindex="0"
                                routerLink="/service"
                                routerLinkActive="active"
                                i18n="@@menu-item-service-modules"
                                >Service modules</a
                            >
                        }
                    </div>
                </mat-menu>
            </li>
        }
    </ul>

    <div class="sidenav__bottom">
        <!-- Admin -->
        @if (auth.isLoggedIn() && (auth.isAdmin() || auth.isSuperAdmin())) {
            <a
                matButton
                class="sidenav__link sidenav__link--trigger"
                [class.sidenav__link--active]="isRouteActive(['/administration', '/organization'])"
                [matMenuTriggerFor]="adminMenu"
                #adminTrigger="matMenuTrigger"
                tabindex="0"
                (keydown.enter)="adminTrigger.openMenu()"
                (menuOpened)="onMenuOpened(adminTrigger)"
                i18n-aria-label="@@sidenav-item-admin"
                aria-label="Admin">
                <mat-icon
                    class="sidenav__icon riege-icon md-24 material-icons"
                    [class.material-icons-outlined]="!isRouteActive(['/administration', '/organization'])"
                    aria-hidden="true"
                    >settings</mat-icon
                >
                <span class="sidenav__label" i18n="@@sidenav-item-admin">Admin</span>
            </a>

            <mat-menu
                #adminMenu="matMenu"
                xPosition="after"
                yPosition="above"
                [overlapTrigger]="false"
                class="riege-menu sidenav__menu sidenav__menu--bottom">
                <div>
                    <p class="sidenav__menu-heading sidenav__menu-heading--company" mat-menu-item disabled>
                        {{ organizationLabel() }}
                    </p>
                    @if (auth.isAdmin() || auth.isSuperAdmin()) {
                        <a
                            mat-menu-item
                            tabindex="0"
                            routerLink="/administration/organization"
                            [class.active]="isRouteActive(['/administration/organization'])"
                            i18n="@@toolbar-menu-manage-organization"
                            >Manage Organization</a
                        >
                    }
                </div>
            </mat-menu>
        }

        <!-- Expand / Collapse toggle -->
        <button
            matButton
            class="sidenav__link sidenav__link--toggle"
            (click)="toggleExpanded()"
            [attr.aria-label]="expanded() ? 'Collapse navigation' : 'Expand navigation'"
            i18n-aria-label="@@sidenav-toggle"
            i18n-matTooltip="@@sidenav-toggle-expand-menu"
            matTooltip="expand menu"
            [matTooltipDisabled]="expanded()">
            <mat-icon
                class="sidenav__icon riege-icon md-24 material-icons"
                [fontIcon]="expanded() ? 'keyboard_double_arrow_left' : 'keyboard_double_arrow_right'"
                aria-hidden="true">
            </mat-icon>
            <span class="sidenav__label" i18n="@@sidenav-toggle-label-close">Close</span>
        </button>
    </div>
</nav>

<button
    mat-fab
    class="sidenav__mobile-fab"
    (click)="openMobileMenu()"
    aria-label="Open navigation"
    aria-haspopup="true">
    <mat-icon class="riege-icon">menu</mat-icon>
</button>
